import { I18n } from '@calendly/i18n';
import { Banner, Body, Footer, Header, Popup } from '@calendly/ui/components/popup';
import { BodyText } from '@calendly/ui/components/typography';
// Asset lives under src/images/modals (shared modals folder). Relative import so Jest
// resolves it without the webpack-only `~images` alias.
// @ts-expect-error -- webpack resolves asset imports at build-time
import welcomeImage from '../../../../images/modals/brand-refresh-welcome-modal.png';

/** Fills the CUI Banner slot so the hero image covers the banner area. */
const bannerImageCss = "b1v1pnj7";
interface BrandRefreshWelcomeModalProps {
  isOpen: boolean;
  /** Secondary action + X: dismiss and reveal the nav tour card. */
  onExploreNow: () => void;
  /** Primary action: dismiss and launch the nav Spotlight tour. */
  onTakeTour: () => void;
}

/**
 * Post-opt-in welcome modal for Brand Refresh: banner image, copy, and Explore now / Take a tour.
 */
export const BrandRefreshWelcomeModal = ({
  isOpen,
  onExploreNow,
  onTakeTour
}: BrandRefreshWelcomeModalProps) => <Popup isOpen={isOpen} isBlocking withCloseButton onClose={onExploreNow} size="medium" data-testid="brand-refresh-welcome-modal">
    <Banner size="large">
      <img alt="" src={welcomeImage} className={bannerImageCss} />
    </Banner>
    <Header title={I18n.t('publisher.app_shell.brand_refresh_beta.welcome.title')} />
    <Body>
      <BodyText>{I18n.t('publisher.app_shell.brand_refresh_beta.welcome.body')}</BodyText>
    </Body>
    <Footer cancelLabel={I18n.t('publisher.app_shell.brand_refresh_beta.welcome.explore_now')} confirmLabel={I18n.t('publisher.app_shell.brand_refresh_beta.welcome.take_a_tour')} onCancel={onExploreNow} onConfirm={onTakeTour} />
  </Popup>;

require("./BrandRefreshWelcomeModal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./BrandRefreshWelcomeModal.tsx");